const InlineSVG = ({ src, className, children }) => {
  let svg
  try {
    svg = require(`../../../static/images/${src}.svg`).default // Ensure the path resolves correctly
  } catch (e) {
    console.error(`SVG not found: ${src}`, e)
    svg = '<!-- SVG not found -->' // Fallback content
  }

  return (
    <div
      className={`velorbis-customizer-inline-svg${
        className ? ' ' + className : ''
      }`}
      dangerouslySetInnerHTML={{ __html: svg }}
    >
      {children}
    </div>
  )
}

export default InlineSVG
